import React, { useState } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

export const PdfDownloadButton = ({ label, title, onDownload }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleClick = async () => {
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      await onDownload();
    } catch (e) {
      setError(e?.message || 'Download failed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Tooltip title={error || title || 'Download PDF'}>
      <Box
        component="button"
        type="button"
        onClick={handleClick}
        disabled={busy}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.6,
          maxWidth: '100%',
          px: 1,
          py: 0.5,
          borderRadius: 1.5,
          border: error ? '1px solid #b71c1c' : '1px solid rgba(80,0,0,0.2)',
          bgcolor: error ? 'rgba(183,28,28,0.06)' : 'transparent',
          color: error ? '#b71c1c' : '#500000',
          cursor: busy ? 'progress' : 'pointer',
          font: 'inherit',
          textAlign: 'left',
          '&:hover': { bgcolor: 'rgba(233,228,220,0.9)' },
        }}
      >
        {busy ? (
          <CircularProgress size={13} sx={{ color: '#500000' }} />
        ) : (
          <PictureAsPdfIcon sx={{ fontSize: '1rem' }} />
        )}
        <Typography
          component="span"
          sx={{
            fontWeight: 800,
            fontSize: '0.85rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default PdfDownloadButton;
